import React, { Component } from 'react';
import { bool, func, any, string, node } from 'prop-types';

import styles from './Tab.scss';

const cx = require('classnames/bind').bind(styles);

import collapseIcon from './images/ic_collapse.svg';
import expandIcon from './images/ic_expand.svg';

class Tab extends Component {
  handleClick = evt => {
    const { onActive, onClick, value } = this.props;

    onActive();
    onClick(value, evt);
  };

  render() {
    const { label, children, selected } = this.props;

    return (
      <div className={styles.item}>
        {/* label */}
        <div
          className={cx('label', {
            active: selected,
          })}
          onClick={this.handleClick}
        >
          <span className={styles.label}>{label}</span>
          {/* for animation */}
          <img className={styles.collapseIcon} src={collapseIcon} />
          <img className={styles.expandIcon} src={expandIcon} />
        </div>
        <div
          className={cx('itemContent', {
            visible: selected,
            hidden: !selected,
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}

Tab.propTypes = {
  children: node,
  firstRender: bool,
  isActive: bool,
  label: string,
  selected: bool,
  value: any,
  onActive: func,
  onClick: func,
};

Tab.defaultProps = {
  firstRender: true,
  selected: false,
  value: '',
  children: null,
  isActive: false,
  onActive: () => {},
  onClick: () => {},
  label: '',
};

export default Tab;



// WEBPACK FOOTER //
// ./app/components/Accordion/components/Tab/Tab.jsx